import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import OverviewPage from "./pages/OverviewPage";
import SwitchPage from "./pages/SwitchPage";
import SwitchIIPage from "./pages/SwitchIIPage";
import FirstAdvantagePage from "./pages/FirstAdvantagePage";
import NAOPage from "./pages/NAOPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<OverviewPage />} />
          <Route path="/switch" element={<SwitchPage />} />
          <Route path="/switch2amplify126" element={<SwitchIIPage />} />
          <Route path="/firstadvantage" element={<FirstAdvantagePage />} />
          <Route path="/nao" element={<NAOPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
